import React from "react";
import image_2 from "../images/where_we_work/where-we-work-02-tablet.jpg";
import image_3 from "../images/where_we_work/where-we-work-03-mobile.jpg";
import image_1 from "../images/where_we_work/where-we-work_desktop.jpg";

const Infrastructure = () => {
  return (
    <section className="">
      <div className="ms-35 me-35">
        <div className="where-we-work_desktop">
          <img src={image_1} className="infrastructure-img" alt="loading..." />
        </div>
        <div className="where-we-work_tablet">
          <img src={image_2} className="infrastructure-img" alt="loading..." />
        </div>
        <div className="where-we-work_mobile">
          <img src={image_3} className="infrastructure-img" alt="loading..." />
        </div>
      </div>
    </section>
  );
};

export default Infrastructure;
